export default "__VITE_ASSET__41184c7e__"